import { NgModule } from '@angular/core';
import { PacedCourseOfferingActionsService } from './messaging/paced-course-offering-actions.service';
import { CourseEssenceService } from './api/course-essence/course-essence.service';
import { ContinuousCourseOfferingActionsService } from './messaging/continuous-course-offering-actions.service';
import { ContinuousCourseOfferingService } from './api/continuous-course-offering/continuous-course-offering.service';
import { PacedCourseOfferingService } from './api/paced-course-offering/paced-course-offering.service';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [
    PacedCourseOfferingActionsService,
    ContinuousCourseOfferingActionsService,
    CourseEssenceService,
    PacedCourseOfferingService,
    ContinuousCourseOfferingService
  ],
  bootstrap: []
})
export class ServicesModule {}
